import config from '../../../config/config';
import {
  SystemApi,
  SystemControllerDtoFileListRequest,
  SystemControllerDtoFileListResponse,
} from '../../models/src';
import {
  FILE_LIST_REQUEST,
  FOLDER_LIST_REQUEST,
} from '../../constants/app/fileUploadConstant';
import { fork, takeEvery, all } from 'redux-saga/effects';
const api = new SystemApi(config.API_CLIENT);
import SystemControllerDtoFolderListRequest from '../../models/src/model/SystemControllerDtoFolderListRequest';
import SystemControllerDtoFolderListResponse from '../../models/src/model/SystemControllerDtoFolderListResponse';

function* folderListSaga(payload) {
  try {
    const requestData = new SystemControllerDtoFolderListRequest();
    // requestData.container = payload.container;
    requestData.container = 2;

    const res = yield api.apiSystemFolderListPost(
      { systemControllerDtoFolderListRequest: requestData },
      () => {},
    );

    const data = api.apiClient.deserialize(
      res,
      SystemControllerDtoFolderListResponse,
    );

    if (data.resultCode !== 200) {
      console.log(data);
      throw Error(`Error: ${data.resultCode}`);
    }

    if (payload.callback) {
      payload.callback(data);
    }
    console.log(data);
  } catch (error) {}
}

function* fileListSaga(payload) {
  try {
    const requestData = new SystemControllerDtoFileListRequest();
    requestData.container = payload.container;
    requestData.folderName = payload.folderName;

    const res = yield api.apiSystemFileListPost(
      { systemControllerDtoFileListRequest: requestData },
      () => {},
    );

    const data = api.apiClient.deserialize(
      res,
      SystemControllerDtoFileListResponse,
    );

    if (data.resultCode !== 200) {
      console.log(data);
      throw Error(`Error: ${data.resultCode}`);
    }

    if (payload.callback) {
      payload.callback(data);
    }
  } catch (error) {
    console.error(error);

    if (payload.error) {
      payload.error(error);
    }
  }
}

function* rootSaga() {
  yield all([
    takeEvery(FOLDER_LIST_REQUEST, folderListSaga),
    takeEvery(FILE_LIST_REQUEST, fileListSaga),
  ]);
}

const fileUploadSagas = [fork(rootSaga)];
export default fileUploadSagas;
